/**
 * Shared debug logging utility.
 *
 * Enable via:
 *   - URL param: ?debug=1
 *   - localStorage: localStorage.setItem("BWS_DEBUG", "1"); location.reload();
 *   - env (dev only): VITE_DEBUG_LOGS=1
 *
 * Default is silent — no console output in production.
 */

const DEBUG_KEY = 'BWS_DEBUG';

export function isDebugEnabled(): boolean {
  if (typeof window !== 'undefined') {
    if (window.location.search.includes('debug=1')) return true;
    try {
      return localStorage.getItem(DEBUG_KEY) === '1';
    } catch {
      /* private browsing */
    }
  }
  return import.meta.env.DEV && import.meta.env.VITE_DEBUG_LOGS === '1';
}

export function debugLog(scope: string, ...args: unknown[]): void {
  if (!isDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(`[${scope}]`, ...args);
}

export function debugWarn(scope: string, ...args: unknown[]): void {
  if (!isDebugEnabled()) return;
  console.warn(`[${scope}]`, ...args);
}
